module.exports = __webpack_public_path__ + "1602ab805b64f5f617d84898bd42a59d.woff";